import TrialLicenseHint from "shared/trial_license_hint.mdx";
import * as React from 'react';
export default {
  TrialLicenseHint,
  React
};